/** Preset label colors (matches dashboard label picker UX). */
export const LABEL_COLOR_SWATCHES = [
  '#9CA3AF',
  '#F87171',
  '#FB923C',
  '#FBBF24',
  '#84CC16',
  '#38BDF8',
  '#818CF8',
  '#C084FC',
];

export function pickRandomLabelSwatch() {
  const i = Math.floor(Math.random() * LABEL_COLOR_SWATCHES.length);
  return LABEL_COLOR_SWATCHES[i];
}
